/**
 * Контроллер предметных операций для ListboxWidget.
 * Реализует выбор и упорядочивание элементов.
 */
class ListboxItemsController {
    constructor(widget) {
        this._w = widget;
    }
    // ── Выбор ──
    select(ids) {
        const arr = Array.isArray(ids) ? ids : [ids];
        this._w.checkboxes().forEach(inp => {
            if (inp.disabled)
                return;
            inp.checked = arr.includes(inp.value);
        });
    }
    selectAll() {
        this.bulkToggle(true);
    }
    unselect(ids) {
        const arr = Array.isArray(ids) ? ids : [ids];
        this._w.checkboxes().forEach(inp => {
            if (inp.disabled)
                return;
            if (arr.includes(inp.value))
                inp.checked = false;
        });
    }
    unselectAll() {
        this._w.checkboxes().forEach(cb => {
            if (cb.disabled)
                return;
            cb.checked = false;
        });
    }
    toggle() {
        this._w.checkboxes().forEach(cb => {
            if (cb.disabled)
                return;
            cb.checked = !cb.checked;
        });
    }
    // ── Порядок ──
    moveUp() {
        const list = this._w.element;
        const blocks = getSelectedBlocks(list);
        for (const block of blocks) {
            const head = block[0];
            const tail = block[block.length - 1];
            const prev = head.previousElementSibling;
            if (!prev)
                continue;
            list.insertBefore(prev, tail.nextSibling);
        }
    }
    moveDown() {
        const list = this._w.element;
        const blocks = getSelectedBlocks(list);
        for (let i = blocks.length - 1; i >= 0; i--) {
            const block = blocks[i];
            const head = block[0];
            const tail = block[block.length - 1];
            const next = tail.nextElementSibling;
            if (!next)
                continue;
            list.insertBefore(next, head);
        }
    }
    // ── Вспомогательные ──
    bulkToggle(flag) {
        this._w.checkboxes().forEach(cb => {
            if (cb.disabled)
                return;
            if (cb.checked !== flag) {
                cb.checked = flag;
            }
        });
    }
}
/** Внутренний помощник: сгруппировать выделенные элементы в блоки */
function getSelectedBlocks(container) {
    const items = Array.from(container.children);
    const blocks = [];
    let cur = [];
    const isChecked = (el) => {
        const inp = el.querySelector('input[type="checkbox"]');
        return !!inp && inp.checked === true;
    };
    for (const el of items) {
        if (isChecked(el))
            cur.push(el);
        else if (cur.length) {
            blocks.push(cur);
            cur = [];
        }
    }
    if (cur.length)
        blocks.push(cur);
    return blocks;
}

export { ListboxItemsController };
